var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"vh-100 align-center align-self-center"},[_c('v-col',[_c('v-progress-linear',{attrs:{"color":"amber darken-3","indeterminate":"","rounded":"","height":"6"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }